// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__2CLx3","modalButtons":"Modal_modalButtons__3QqQ6"};